// Nível raiz (/)
export const HOME = "/"

// Nível 1 (/AlgumaCoisa)
export const NOT_FOUND = "/NotFound"

// Fluxo de Calculadora de Taxas (CTM24)
export const SERVICOS_TAXAS_CTM24 = "/Simuladora"
export const CALCULAR_TAXAS_CTM24 = SERVICOS_TAXAS_CTM24 + "/CalcularTaxaServico"
